export const goimomi = {
  companyName: 'FlySync',
  corporateName: 'Goimomi',
  title: 'GOIMOMI HOLIDAYS',
  templateConfig: 'template2',
  email: 'support@goimomi.com',
  phone: '+91 6382220393, 04314973268',
  address:
    '<div><strong>GOIMOMI HOLIDAYS</strong>, <br>5, Ground Floor, Crescent Park Apartment, Hazrath Sulaiman Street, Kaja Nagar, Trichy 620020, Tamil Nadu</div>',
  apiUrl: 'https://b2b.goimomi.com/backend/',
  isFullBGimage: 'Y',
  whatsapp: '94425 63313',
  agentNavigate: 'https://b2b.goimomi.com/auth/login',
  instagram:
    'https://www.instagram.com/goimomi?igsh=NjAzMmt1YzBzZnJm&utm_source=qr',
  facebook: 'https://www.facebook.com/share/1YsxFtFjoe/?mibextid=wwXIfr',
  twitter: 'https://x.com/goimomi',
  linkedin: 'https://in.linkedin.com/company/goimomi',
  youtube: 'https://www.youtube.com/@goimomi',
  sentryDsn:
    'https://67269001d7387ce208d73a9eb29708e3@o4509110763126784.ingest.us.sentry.io/4509110770663424',
  registerAddress: '',
  registerCompanyName: '',
  registerEmail: '',
  registerMobile: '',
  registerNo: '',
  providerCodes: ['TJ'],
  cancellationCharges: '{"DO":"250","IN":"500"}',
  encrypt: 'N',
  securePayment: 'true',
  aboutUs: 'https://goimomi.com/aboutus',
  contactUs: 'https://goimomi.com/contactus',
  navigator: 'Y',
  encryptionSecretKey: 'd1e622507595486ee06db24b1debf11064edd2ba',
};
